// extracted by mini-css-extract-plugin
module.exports = {"block":"block--yAC6O","divider":"divider--LmizE","button":"button--zDHZX"};
    if(module.hot) {
      // 1653630385677
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  